
import { Link } from "react-router-dom";
import AkkhorLayout from "../../../layout/AkkhorLayout";
import List from "../../../component/List";


export default function DanhSachBangHang() {
    let params = '';
    const columns = [
        { name: "id", label: "ID", options: { filter: false, sort: true } },
        { name: "title", label: "Tiêu đề", options: { filter: true, sort: true } },
        { name: "duan_title", label: "Thuộc dự án", options: { filter: true, sort: true } },
        { name: "datecreate", label: "Ngày tạo", }
    ];

    return (<AkkhorLayout idrole="bang-hang">
        <div className="breadcrumbs-area">
            <ul>
                <li>
                    <Link to="/">Trang chủ</Link>
                </li>
                <li>
                    Danh sách bảng hàng
                </li>
            </ul>
        </div>
        <List name="banghang" idrole="bang-hang" params={params} title="" defaultLimit={50} serverSide={true} columns={columns}></List>
    </AkkhorLayout>);
}
